import { gql } from '@apollo/client'

const UPDATE_CONTACT = gql`
  mutation UpdateContact($documentNumber: ID!, $value: String!, $contact: ContactInput!) {
    updateContact(documentNumber: $documentNumber, value: $value, contact: $contact) {
      message
      statusCode
      code
      error
    }
  }
`

export default UPDATE_CONTACT
